<div class="modal">
  <h1 mat-dialog-title>{{'Panel.DeviceSettings' | translate}}</h1>
  <form name="f" #f="ngForm" novalidate formValidTimerRange>
    <mat-dialog-content>
      <!-- Data bus configuration -->
      <div *ngIf="isDataBus" class="container align-button" fxLayout="row" fxLayoutGap="20px">
        <div class="field-container" fxFlex>
          <div *ngIf="isDataBus" class="title">{{"Panel.PanelModelConfiguration" | translate}}</div>
          <mat-form-field class="no-underline no-arrow">
            <mat-select class="input" [ngClass]="{ 'mouse-over-event': !installed }"
              style="color: black;" [(value)]="values.panelModel" [disabled]="installed">
              <mat-option value="0"> {{"Constants.PanelModel.keyswitch" | translate}} </mat-option>
              <mat-option value="5"> {{"Constants.PanelModel.dsc" | translate}} </mat-option>
              <mat-option value="6"> {{"Constants.PanelModel.paradox" | translate}} </mat-option>
            </mat-select>    
            <mat-icon class="select-arrow-icon">keyboard_arrow_down</mat-icon>
          </mat-form-field>
        </div>
        <button
            mat-icon-button
            matTooltip='{{"Panel.Help" | translate}}'
            matTooltipShowDelay="750"
            matTooltipPosition="after"
            (click)="databusHelpUrl()"
            aria-hidden="false"
            aria-label="Help"
            class="custom-icon"
        > 
          <mat-icon svgIcon="help_icon" class="icon"></mat-icon>
        </button>
        <button class="modal-btn"
          type="button"
          [disabled]="validSetButton('panelModel')" 
          (click)="onConfigPanel()"
        > {{ (installed ? "Panel.Uninstall" : "Panel.SetUp") | translate}}
        </button>
      </div>
      <!-- Siren time -->
      <div class="container align-button" fxLayout="row" fxLayoutGap="20px">
        <div class="field-container" fxFlex>
          <div class="title">{{"Panel.SirenTimeMin" | translate}}</div>
          <mat-form-field class="no-underline">
            <div class="custom-number-input">
              <input matInput name="TimeSiren" type="number" [(ngModel)]="values.timeSiren" #TimeSiren="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.timeSiren }"
                (ngModelChange)="validSirenTimeRange()" matInput timeSiren required 
                autocomplete="off" 
                [errorStateMatcher]="timeSirenErrorStatMatcher" 
                [disabled]="!isConfig.timeSiren"
              />
              <div *ngIf="isConfig.timeSiren" class="arrows">
                <button class="arrow up" (click)="increment('timeSiren')"><mat-icon class="mat-icon">keyboard_control_key</mat-icon></button>
                <button class="arrow down" (click)="decrement('timeSiren')"><mat-icon class="mat-icon">keyboard_arrow_down</mat-icon></button>
              </div>
            </div>
            <mat-error *ngIf="TimeSiren.invalid && TimeSiren.errors?.required">{{'Panel.RequiredField' | translate}}</mat-error>
            <mat-error *ngIf="timeSirenErrorStatMatcher.getExists()">{{'Panel.InvalidValue' | translate}}</mat-error>
          </mat-form-field>
        </div>
        <button
            mat-icon-button
            matTooltip='{{"Panel.Edit" | translate}}'
            matTooltipShowDelay="750"
            matTooltipPosition="after"
            (click)="clickConfig('timeSiren')"
            aria-hidden="false"
            aria-label="Edit"
            class="custom-icon"
        > 
          <mat-icon svgIcon="edit_square_icon" class="icon"></mat-icon>
        </button>
        <button class="modal-btn-white"
          type="button"
          [disabled]="validGetButton('timeSiren')"
          [ngClass]="validGetButton('timeSiren') ? 'modal-btn-disabled' : ''" 
          (click)="sendCommand('timeSiren', false)"
        > {{ "Panel.Consult" | translate}}
        </button>
        <button class="modal-btn"
          type="button"
          [disabled]="validSetButton('timeSiren')" 
          [ngClass]="validSetButton('timeSiren') ? 'modal-btn-disabled' : ''" 
          (click)="isConfiguration('timeSiren') ? sendCommand('timeSiren', true) : clickConfig('timeSiren')"
        > {{ (isConfiguration('timeSiren') ? "Panel.SetUp" : "Panel.Cancel") | translate}}
        </button>
      </div>

      <!-- Zone Delay Time Entry -->
      <div class="container align-button" fxLayout="row" fxLayoutGap="20px">
        <div class="field-container" fxFlex>
          <div class="title">{{"Panel.DelayZoneTimeSeg" | translate}}</div>
          <mat-form-field class="no-underline">
            <div class="custom-number-input">
              <input matInput name="ZoneDelayTime" type="number" [(ngModel)]="values.zoneDelayTime" #ZoneDelayTime="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.zoneDelayTime }"
                (ngModelChange)="validZoneTimeRange()" matInput zoneDelayTime required 
                autocomplete="off" 
                [errorStateMatcher]="zoneDelayTimeErrorStatMatcher" 
                [disabled]="!isConfig.zoneDelayTime"
              />
              <div *ngIf="isConfig.zoneDelayTime" class="arrows">
                <button class="arrow up" (click)="increment('zoneDelayTime')"><mat-icon class="mat-icon">keyboard_control_key</mat-icon></button>
                <button class="arrow down" (click)="decrement('zoneDelayTime')"><mat-icon class="mat-icon">keyboard_arrow_down</mat-icon></button>
              </div>
            </div>
            <mat-error *ngIf="ZoneDelayTime.invalid && ZoneDelayTime.errors?.required">{{'Panel.RequiredField' | translate}}</mat-error>
            <mat-error *ngIf="zoneDelayTimeErrorStatMatcher.getExists()">{{'Panel.InvalidValue' | translate}}</mat-error>
          </mat-form-field>
        </div>
        <button
            mat-icon-button
            matTooltip='{{"Panel.Edit" | translate}}'
            matTooltipShowDelay="750"
            matTooltipPosition="after"
            (click)="clickConfig('zoneDelayTime')"
            aria-hidden="false"
            aria-label="Edit"
            class="custom-icon"
        > 
          <mat-icon svgIcon="edit_square_icon" class="icon"></mat-icon>
        </button>
        <button class="modal-btn-white"
          type="button"
          [disabled]="validGetButton('zoneDelayTime')"
          [ngClass]="validGetButton('zoneDelayTime') ? 'modal-btn-disabled' : ''" 
          (click)="sendCommand('zoneDelayTime', false)"
        > {{ "Panel.Consult" | translate}}
        </button>
        <button class="modal-btn"
          type="button"
          [disabled]="validSetButton('zoneDelayTime')" 
          [ngClass]="validSetButton('zoneDelayTime') ? 'modal-btn-disabled' : ''" 
          (click)="isConfiguration('zoneDelayTime') ? sendCommand('zoneDelayTime', true) : clickConfig('zoneDelayTime')"
        > {{ (isConfiguration('zoneDelayTime') ? "Panel.SetUp" : "Panel.Cancel")  | translate}}
        </button>
      </div>

      <!-- Delay Time Exit -->
      <div class="container align-button" style="margin-bottom: 0"  fxLayout="row" fxLayoutGap="20px">
        <div class="field-container" fxFlex>
          <div class="title">{{"Panel.DelayTimeSeg" | translate}}</div>
          <mat-form-field class="no-underline">
            <div class="custom-number-input">
              <input matInput name="DelayTime" type="number" [(ngModel)]="values.delayTime" #DelayTime="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.delayTime }"
                (ngModelChange)="validDelayTimeRange()" matInput delayTime required 
                autocomplete="off" 
                [errorStateMatcher]="delayTimeErrorStatMatcher" 
                [disabled]="!isConfig.delayTime"
              />
              <div *ngIf="isConfig.delayTime" class="arrows">
                <button class="arrow up" (click)="increment('delayTime')"><mat-icon class="mat-icon">keyboard_control_key</mat-icon></button>
                <button class="arrow down" (click)="decrement('delayTime')"><mat-icon class="mat-icon">keyboard_arrow_down</mat-icon></button>
              </div>
            </div>
            <mat-error *ngIf="DelayTime.invalid && DelayTime.errors?.required">{{'Panel.RequiredField' | translate}}</mat-error>
            <mat-error *ngIf="delayTimeErrorStatMatcher.getExists()">{{'Panel.InvalidValue' | translate}}</mat-error>
          </mat-form-field>
        </div>
        <div class="field-container" fxFlex>
          <div class="title">{{"Panel.PanelArmType" | translate}}</div>
          <mat-form-field class="no-underline no-arrow">
            <mat-select class="input" [ngClass]="{ 'mouse-over-event': isConfig.delayTime }" style="color: black;" [(value)]="values.panelArm">
              <mat-option [value]="armStates.total"> {{"Constants.PanelArmStates.total" | translate}} </mat-option>
              <mat-option [value]="armStates.perimetral"> {{"Constants.PanelArmStates.perimetral" | translate}} </mat-option>
            </mat-select>    
            <mat-icon class="select-arrow-icon">keyboard_arrow_down</mat-icon>
          </mat-form-field>
        </div>
        <button
            mat-icon-button
            matTooltip='{{"Panel.Edit" | translate}}'
            matTooltipShowDelay="750"
            matTooltipPosition="after"
            (click)="clickConfig('delayTime')"
            aria-hidden="false"
            aria-label="Edit"
            class="custom-icon"
        > 
          <mat-icon svgIcon="edit_square_icon" class="icon"></mat-icon>
        </button>
        <button class="modal-btn-white"
          type="button"
          [disabled]="validGetButton('delayTime')"
          [ngClass]="validGetButton('delayTime') ? 'modal-btn-disabled' : ''" 
          (click)="sendCommand('delayTime', false)"
        > {{ "Panel.Consult" | translate}}
        </button>
        <button class="modal-btn"
          type="button"
          [disabled]="validSetButton('delayTime')" 
          [ngClass]="validSetButton('delayTime') ? 'modal-btn-disabled' : ''" 
          (click)="isConfiguration('delayTime') ? sendCommand('delayTime', true) : clickConfig('delayTime')"
        > {{ (isConfiguration('delayTime') ? "Panel.SetUp" : "Panel.Cancel")  | translate}}
        </button>
      </div>
      
      <!-- Delay Exit - Zone Configurations -->
      <div class="container align-button" fxLayout="row" fxLayoutGap="20px" style="margin-bottom: 0px">
        <div class="field-container" fxFlex>
          <div class="title">
            <p [innerHTML]="'Panel.DelayExitZoneConfiguration' | translate"></p>
          </div>
        </div>
      </div>
      <div class="container align-button" fxLayout="row" fxLayoutGap="20px">
        <mat-checkbox
          color="primary"
          class="user-check title"
          [title]="('Panel.DelayExitZoneKeyring' | translate)"
          [disabled]="!isConfig.delayTime"
          [checked]="values.configKeyring"
          (change)="switchCheckbox('configKeyring')"
        >
          {{ "Panel.DelayExitZoneKeyring" | translate }}
        </mat-checkbox>
        <mat-checkbox
          color="primary"
          class="user-check title"
          [title]="('Panel.DelayExitZoneKeypad' | translate)"
          [disabled]="!isConfig.delayTime"
          [checked]="values.configKeypad"
          (change)="switchCheckbox('configKeypad')"
        >
          {{ "Panel.DelayExitZoneKeypad" | translate }}
        </mat-checkbox>
      </div>

      <!-- Audible Zone Delay -->
      <div class="container align-button" fxLayout="row" fxLayoutGap="20px">
        <div class="field-container" fxFlex>
          <div class="title">{{"Panel.DelayZoneSound" | translate}}</div>
          <mat-slide-toggle  class="custom-toggle"
            name="AudibleDelayZone" 
            color="primary" 
            [(ngModel)]="values.audibleDelayZone" 
            #AudibleDelayZone="ngModel" 
            [disabled]="!isConfig.audibleDelayZone || isSet.audibleDelayZone"
          >
            {{ (values.audibleDelayZone ? 'Panel.Enabled' : 'Panel.Disabled') | translate }}
          </mat-slide-toggle>
        </div>
        <button
            mat-icon-button
            matTooltip='{{"Panel.Edit" | translate}}'
            matTooltipShowDelay="750"
            matTooltipPosition="after"
            (click)="clickConfig('audibleDelayZone')"
            aria-hidden="false"
            aria-label="Edit"
            class="custom-icon"
        > 
          <mat-icon svgIcon="edit_square_icon" class="icon"></mat-icon>
        </button>
        <button class="modal-btn-white"
          type="button"
          [disabled]="validGetButton('audibleDelayZone')"
          [ngClass]="validGetButton('audibleDelayZone') ? 'modal-btn-disabled' : ''" 
          (click)="sendCommand('audibleDelayZone', false)"
        > {{ "Panel.Consult" | translate}}
        </button>
        <button class="modal-btn"
          type="button"
          [disabled]="validSetButton('audibleDelayZone')" 
          [ngClass]="validSetButton('audibleDelayZone') ? 'modal-btn-disabled' : ''" 
          (click)="isConfiguration('audibleDelayZone') ? sendCommand('audibleDelayZone', true) : clickConfig('audibleDelayZone')"
        > {{(isConfiguration('audibleDelayZone') ? "Panel.SetUp" : "Panel.Cancel")  | translate}}
        </button>
      </div>
      <div *ngIf="!data.panel.isCommunicator && data.partitions != 0">
        <!-- Disarm PIN -->
        <div class="container align-button" fxLayout="row" fxLayoutGap="20px">
          <div class="field-container" fxFlex>
            <div class="title">{{"Panel.Password" | translate}}</div>
            <mat-form-field class="no-underline">
              <input matInput name="DissarmPass" maxlength="4"
                [(ngModel)]="values.dissarmPass" #DissarmPass="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.dissarmPass }"
                (input)="inputValidatorNumeric($event, 'dissarmPass')"
                (ngModelChange)="validPasswords('dissarmPass')" matInput zoneDelayTime required 
                autocomplete="off" 
                [errorStateMatcher]="dissarmPassErrorStatMatcher"
                [disabled]="!isConfig.dissarmPass"
              />
              <mat-error *ngIf="DissarmPass.invalid && DissarmPass.errors?.required">{{"Panel.RequiredField" | translate}}</mat-error>
              <mat-error *ngIf="dissarmPassErrorStatMatcher.getExists()">{{"Panel.InvalidValue" | translate}}</mat-error>
            </mat-form-field>
          </div>
          <div class="field-container" fxFlex>
            <div class="title">{{"Panel.AccountNumber" | translate}}</div>
            <mat-form-field class="no-underline">
              <input matInput name="AccountDissarm" maxlength="4"
                [(ngModel)]="values.accountDissarm" #AccountDissarm="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.dissarmPass }"
                (input)="inputValidatorHexa($event, 'account')"
                (ngModelChange)="validAccount('accountDissarm')" matInput accountDissarm required 
                autocomplete="off" 
                [errorStateMatcher]="accountDissarmErrorStatMatcher" 
                [disabled]="!isConfig.dissarmPass"
              />
              <mat-error *ngIf="AccountDissarm.invalid && AccountDissarm.errors?.required">{{"Panel.RequiredField" | translate}}</mat-error>
              <mat-error *ngIf="accountDissarmErrorStatMatcher.getExists()">{{"Panel.InvalidValue" | translate}}</mat-error>
            </mat-form-field>
          </div>
          <button
              mat-icon-button
              matTooltip='{{"Panel.Edit" | translate}}'
              matTooltipShowDelay="750"
              matTooltipPosition="after"
              (click)="clickConfig('dissarmPass')"
              aria-hidden="false"
              aria-label="Edit"
              class="custom-icon"
          > 
            <mat-icon svgIcon="edit_square_icon" class="icon"></mat-icon>
          </button>
          <button class="modal-btn"
            type="button"
            [disabled]="validSetButton('dissarmPass') && isConfiguration('dissarmPass')" 
            [ngClass]="(validSetButton('dissarmPass') && isConfiguration('dissarmPass')) ? 'modal-btn-disabled' : ''" 
            (click)="isConfiguration('dissarmPass') ? sendCommand('dissarmPass', true) : clickConfig('dissarmPass')"
          > {{ (isConfiguration('dissarmPass') ? 'Panel.SetUp' : 'Panel.Cancel') | translate}}
          </button>
        </div>
        <!-- Duress PIN -->
        <div class="container align-button" fxLayout="row" fxLayoutGap="20px">
          <div class="field-container" fxFlex>
            <div class="title">{{"Panel.DuressPassword" | translate}}</div>
            <mat-form-field class="no-underline">
              <input matInput name="CoercionPass" maxlength="4"
                [(ngModel)]="values.coercionPass" #CoercionPass="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.coercionPass }"
                (input)="inputValidatorNumeric($event, 'coercionPass')"
                (ngModelChange)="validPasswords('coercionPass')" matInput coercionPass required 
                autocomplete="off" 
                [errorStateMatcher]="coercionPassErrorStatMatcher" 
                [disabled]="!isConfig.coercionPass"
              />
              <mat-error *ngIf="CoercionPass.invalid && CoercionPass.errors?.required">{{"Panel.RequiredField" | translate}}</mat-error>
              <mat-error *ngIf="coercionPassErrorStatMatcher.getExists()">{{"Panel.InvalidValue" | translate}}</mat-error>
            </mat-form-field>
          </div>
          <div class="field-container" fxFlex>
            <div class="title">{{"Panel.AccountNumber" | translate}}</div>
            <mat-form-field class="no-underline">
              <input matInput name="AccountCoercion" maxlength="4"
                [(ngModel)]="values.accountCoercion" #AccountCoercion="ngModel" 
                class="input" [ngClass]="{ 'mouse-over-event': isConfig.coercionPass }"
                (input)="inputValidatorHexa($event, 'account')"
                (ngModelChange)="validAccount('accountCoercion')" matInput accountCoercion required 
                autocomplete="off" 
                [errorStateMatcher]="accountCoercionErrorStatMatcher" 
                [disabled]="!isConfig.coercionPass"
              />
              <mat-error *ngIf="AccountCoercion.invalid && AccountCoercion.errors?.required">{{'Panel.RequiredField' | translate}}</mat-error>
              <mat-error *ngIf="accountCoercionErrorStatMatcher.getExists()">{{'Panel.InvalidValue' | translate}}</mat-error>
            </mat-form-field>
          </div>
          <button
              mat-icon-button
              matTooltip='{{"Panel.Edit" | translate}}'
              matTooltipShowDelay="750"
              matTooltipPosition="after"
              (click)="clickConfig('coercionPass')"
              aria-hidden="false"
              aria-label="Edit"
              class="custom-icon"
          > 
            <mat-icon svgIcon="edit_square_icon" class="icon"></mat-icon>
          </button>
          <button class="modal-btn"
            type="button"
            [disabled]="validSetButton('coercionPass') && isConfiguration('coercionPass')" 
            [ngClass]="(validSetButton('coercionPass') && isConfiguration('coercionPass')) ? 'modal-btn-disabled' : ''" 
            (click)="isConfiguration('coercionPass') ? sendCommand('coercionPass', true) : clickConfig('coercionPass')"
          > {{ (isConfiguration('coercionPass') ? 'Panel.SetUp' : 'Panel.Cancel') | translate}}
          </button>
        </div>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button class="modal-btn op-button" type="button" [disabled]="false" (click)="onCancelClick()">
        {{"Shared.Close" | translate}}
      </button>
    </mat-dialog-actions >
  </form>
  <button class="close-button" (click)="onCancelClick()">
      <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
